<template>
  <transition name="fade">
    <div class="modal-email-preview">
      <div class="lv3-title-text">Email Preview</div>
      <div class="email-preview-container">
        <div class="email-preview-wrapper epw-title">
          <div class="column30 mr10">Kriteria Penilaian</div>
          <div class="column25 mr10">Tgl Efektif</div>
          <div class="column25 mr10">Tgl Berakhir</div>
          <div class="column20 mr10">Nilai Rata-Rata</div>
        </div>
        <div class="email-preview-wrapper" v-for="(item, i) in $store.state.modalStore.spmEmail['detail']" :key="i">
          <div class="column30 mr10">{{ item.kriteria_penilaian }}</div>
          <div class="column25 mr10">{{ formatDate(item.spm_performance_period_from) }}</div>
          <div class="column25 mr10">{{ formatDate(item.spm_performance_period_to) }}</div>
          <div class="column20 mr10">{{ curencyDelimiter(item.average_grade) }}</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      email: null,
      customText : null,
      tempText : null,
      data: {
        jabatan: 'Komisaris Utama',
        name: 'Bhakti',
        phoneNumber: '+62 8123123124',
        email: 'bhakti@graha.com'
      },
    }
  },
  created() {
  },
  methods: {
    closeModal() {
      const self = this
      self.$store.commit('modalStore/SET_KOMISARIS_MODAL', false)
    },
    confirm() {
      this.$emit('confirmed', this.data)
    }
  }
}
</script>

<style scoped>
.email-preview-container {
  width: 100%;
  height: 80%;
}

.email-preview-wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  font-size: 11px;
}

.epw-title {
  font-weight: bold;
  margin-bottom: 10px;
}
</style>
